// Shared design tokens for the PERL dark theme
export const perlColors = {
  brandColor: "#ff6034", // perl orange
  background: "#191A1B",
  surface: "#242728",
  textPrimary: "#F1F2F3",
  textSecondary: "#798286",
  border: "rgba(241, 242, 243, 0.08)",
  white: "#FFFFFF",
  black: "#000000",
};

export const perlTypography = {
  family: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  title: {
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 300,
    fontSize: "42px",
    lineHeight: "40px",
    letterSpacing: "0.3px",
  },
  headline: {
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.3px",
  },
  paragraph: {
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.3px",
  },
  label: {
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.3px",
  },
  labelSmall: {
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "0.3px",
  },
};

export const perlSpacing = {
  mainPadding: "32px",
  sectionSpacing: "48px",
  containerSpacing: "16px",
  componentPadding: "12px",
  buttonPaddingX: "24px",
  buttonPaddingY: "8px",
};

export default {
  perlColors,
  perlTypography,
  perlSpacing,
};
